import api from "./api";

export const getProfile = async () => {
  return api
    .get({
      endpoint: "/owner/profile",
      port: process.env.REACT_APP_PORT_OWNER,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
